import axios from 'axios';

/**
 * Resolve the backend base URL dynamically.
 *
 * - In dev / preview: honors REACT_APP_BACKEND_URL from .env
 * - In production (or any deployed origin that doesn't match the .env value):
 *   uses window.location.origin so the frontend talks to whichever domain the
 *   user opened the site with. This makes deployments to custom domains
 *   (e.g. bitgonode.com) work without rebuilding.
 */
function resolveBackendUrl() {
  const envUrl = process.env.REACT_APP_BACKEND_URL || '';
  if (typeof window === 'undefined') return envUrl;
  try {
    const currentOrigin = window.location.origin;
    // If we're running on the same host as the env value, use the env value.
    if (envUrl && new URL(envUrl).host === window.location.host) {
      return envUrl;
    }
    // Otherwise, we've been deployed to a new domain (custom domain, prod, etc.)
    // — use the origin the browser is on so /api routes to the correct backend.
    return currentOrigin;
  } catch (_e) {
    return envUrl || (typeof window !== 'undefined' ? window.location.origin : '');
  }
}

const BACKEND_URL = resolveBackendUrl();
export const API = `${BACKEND_URL}/api`;
// Named export so components using WebSockets or direct fetch can pick up the
// same dynamically-resolved backend URL rather than hardcoding process.env.
export const BACKEND = BACKEND_URL;
export { resolveBackendUrl };

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Attach JWT token if available
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('cx_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default api;
